import { localize } from '@vee-validate/i18n';
import { configure } from 'vee-validate';
import { defineRule } from 'vee-validate';
import { required, email, numeric } from '@vee-validate/rules';
import { Directives } from 'bootstrap-vue-next';
import { createI18n } from 'vue-i18n';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import './bootstrap';

import et from '@vee-validate/i18n/dist/locale/et.json';
import ru from '@vee-validate/i18n/dist/locale/ru.json';

import VeeAttributes from './includes/VeeValidateAttributes';
import messages from './includes/messages';

import AdType from './components/AdType.vue';
import Client from './components/Client.vue';
import Content from './components/Content.vue';
import Dates from './components/Dates.vue';
import Intro from './components/Intro.vue';
import Newspapers from './components/Newspapers.vue';
import Payment from './components/Payment.vue';
import Privacy from './components/Privacy.vue';
import Terms from './components/Terms.vue';
import ThankYou from './components/ThankYou.vue';
import Navbar from './components/Navbar.vue';
import PriceList from './components/PriceList.vue';
import Steps from './components/Steps.vue';
import SinglePriceInfo from './components/SinglePriceInfo.vue';
import { createApp } from 'vue';
import { Cropper } from 'vue-advanced-cropper'
import { createPinia } from 'pinia';
import 'vue-advanced-cropper/dist/style.css';
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import App from './App.vue';
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import "vue-select/dist/vue-select.css";

let locale = "et";

let i18n = createI18n({
    legacy: false,
    locale: locale,
    messages,
    silentTranslationWarn: true
});

defineRule('required', required);
defineRule('email', email);
defineRule('numeric', numeric);

const app = createApp(App);

app.use(i18n);
const pinia = createPinia();
app.use(pinia);
app.use(Vue3Toastify, {
    position: "top-center",
    clearOnUrlChange: false
});

for (const name in Directives) {
  app.directive(name.replace(/^v/, ''), Directives[name]);
}

app.component('terms', Terms);
app.component('privacy', Privacy);
app.component('thankYou', ThankYou);
app.component('intro', Intro);
app.component('adType', AdType);
app.component('newspapers', Newspapers);
app.component('client', Client);
app.component('adContent', Content);
app.component('dates', Dates);
app.component('payment', Payment);
app.component('VueDatePicker', VueDatePicker);
app.component('cropper', Cropper);

app.component('navbar', Navbar);
app.component('steps', Steps);
app.component('price-list', PriceList);

app.component('singlePrice', SinglePriceInfo);

configure({
  generateMessage: localize({
    en: VeeAttributes.en,
    et: {...VeeAttributes.et, ...et},
    ru: {...VeeAttributes.ru, ...ru},
  }),
});

if (process.env.MIX_ROLLBAR_ENV === "production") {
    var RollbarPlugin = require('./rollbar').default;
    app.use(RollbarPlugin);
}

app.mount('#app');